import { SyncAdapter } from '../LowSync'

interface ITaroStoarge {
  getStorageSync: (key: string) => string
  setStorageSync: (key: string, data: string) => void
}

/**
 * Taro实现，用于小程序等特殊环境
 */
export class TaroStorage<T> implements SyncAdapter<T> {
  #key: string
  #storage: ITaroStoarge

  constructor(key: string, storage: ITaroStoarge) {
    this.#key = key
    this.#storage = storage
  }

  read(): T | null {
    const value = this.#storage.getStorageSync(this.#key)

    if (!value) {
      return null
    }

    return JSON.parse(value) as T
  }

  write(obj: T): void {
    this.#storage.setStorageSync(this.#key, JSON.stringify(obj))
  }
}
